module.exports = __webpack_public_path__ + "static/media/groceryListIcon2.c60fec1f.svg";